import { render, staticRenderFns } from "./EditCharacteristic.vue?vue&type=template&id=44d4309e&scoped=true&"
import script from "./EditCharacteristic.vue?vue&type=script&lang=ts&"
export * from "./EditCharacteristic.vue?vue&type=script&lang=ts&"
import style0 from "./EditCharacteristic.vue?vue&type=style&index=0&id=44d4309e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44d4309e",
  null
  
)

export default component.exports